import Config from '../../AppConfig';
import { get, put } from './core/fetch';

export const getNotifications = async () => {
	try {
		return await get(`${Config.mlcApiPrefix}/popup-notifications`, {
			withAuth: true,
			noGateway: false,
			includeCredentials: true,
		});
	} catch (Error) {
		return null;
	}
};

export const sendNotificationsAcknowledgement = async (
	notificationId: number
) => {
	try {
		await put(
			`${Config.mlcApiPrefix}/popup-notifications/${notificationId}/acknowledge`,
			undefined,
			{
				withAuth: true,
				noGateway: false,
				includeCredentials: true,
			}
		);
	} catch (e) {
		// noop
	}
	return;
};
